module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAfklEQVR42u3aoRWAQAxEwa2R1iiLnlg6OMShyIhv815GRSRtM7kAAAAAAAAAAAAAADAcIMfZne4ry3bnfx0AAAAAAAAAAAAAAAAAAAAAoHlb4G8BAAAAAAAAABxCAAAAAAAAAAAAAAAAAAAAwGQAn6IAAAAAAAAAAAAAAIzqAXmaF3lp0QfZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Sweden.png
// module id = I9mj
// module chunks = 0 62 63